import React from 'react';
import { usePreferences } from '@context/preferences.context';
import Environment from '@config/index';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import styles from './app-store-button.module.scss';

type IconSizeType = {
  width?: number;
  height?: number;
};

type AppStoreButtonProps = {
  platform: 'android' | 'ios';
  url: string;
  size?: IconSizeType;
  className?: string;
};

const AppStoreButton: React.FC<AppStoreButtonProps> = (props) => {
  const { platform, size, className, url } = props;
  const { language } = usePreferences();
  const { t } = useTranslation('default-layout');

  const isAndroid = platform === 'android';

  const [lang]: string[] = language.split('-');

  const iconPath = `${Environment.assetsPath}/images/mobile/${platform}/${
    isAndroid ? 'google-play' : 'apple-app'
  }-store-btn_${lang}.svg`;

  return (
    <a
      tabIndex={0}
      href={url}
      className={clsx(styles.appStoreBtn, className ?? '')}
      target="_blank"
      rel="noreferrer"
      data-vc-dd-action-name={isAndroid ? 'google_play_store_button' : 'app_store_button'}
      data-cy={isAndroid ? 'google-play-store-button' : 'app-store-button'}
    >
      <img
        loading="lazy"
        src={iconPath}
        width={size?.width}
        height={size?.height}
        alt={isAndroid ? t('FOOTER.GET_ANDROID_APP') : t('FOOTER.GET_IOS_APP')}
        className={styles.appStoreBtn__svg}
      />
    </a>
  );
};

export default AppStoreButton;
